import * as React from 'react';
import * as moment from "moment";
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Modal } from 'react-bootstrap';
import { IListItem } from '@nkr/models/index';

import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IProps {
    show: boolean,
    name: string,
    closeLoopManualConfirmTypes: IListItem[],
    onMarkDonated: (donationDate: string, closeType: number) => void,
    onCancel: () => void
}

interface IState {
    donationDate: string,
    closeType: number,
    validation: {
        donationDate: number,
        closeType: boolean
    },
    dirty: boolean
}

class MarkDonated extends React.Component<IProps, IState> {
    readonly state: IState = {
        donationDate: '',
        closeType: 0,
        validation: {
            donationDate: 0,
            closeType: true
        },
        dirty: false
    }

    handleDonationDateChange = (value: string | moment.Moment) => {
        let donationDate = typeof (value) == 'string' ? value : value.format('MM/DD/YYYY');

        this.setState({
            donationDate
        });
    }

    handleCloseTypeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            closeType: parseInt(e.currentTarget.value)
        });
    }

    handleMarkDonated = () => {
        let { donationDate, closeType } = this.state;

        let validation = {
            donationDate: donationDate != '' ? (moment(donationDate, 'MM/DD/YYYY', true).isValid() ? 0 : 2) : 1,
            closeType: closeType > 0
        };

        this.setState({
            validation,
            dirty: true
        }, () => {
            let isValid = this.state.validation.donationDate == 0 && this.state.validation.closeType;

            if (isValid) {
                this.props.onMarkDonated(donationDate, closeType);
            }
        });
    }

    render = () => {
        let { donationDate, closeType } = this.state.validation;
        let isValid = donationDate == 0 && closeType;

        return (
            <Modal show={this.props.show} backdrop='static' onHide={this.props.onCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Mark as Donated
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.dirty && !isValid && (
                        <Alert bsStyle='danger'>
                            The items in red are required {this.state.closeType}
                        </Alert>
                    )}

                    <div style={{ marginBottom: 20 }}>To mark <strong>{this.props.name}</strong> as donated, please complete the following:</div>
                    <Form horizontal>
                        <FormGroup validationState={this.state.dirty && this.state.validation.donationDate > 0 ? 'error' : null}>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Donation Date:</Col>
                            <Col xs={12} lg={8}>
                                <div style={{ width: '60%' }}>
                                    <DateTime
                                        value={this.state.donationDate}
                                        input={true}
                                        dateFormat={"MM/DD/YYYY"}
                                        closeOnSelect={true}
                                        inputProps={{ className: "form-control" }}
                                        onChange={this.handleDonationDateChange}
                                    />
                                </div>

                                {this.state.dirty && this.state.validation.donationDate == 2 && (
                                    <HelpBlock>The donation date format must match MM/DD/YYYY</HelpBlock>
                                )}
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={this.state.dirty && !this.state.validation.closeType ? 'error' : null}>
                            <Col xs={12} lg={3} componentClass={ControlLabel}>Donation Type:</Col>
                            <Col xs={12} lg={8}>
                                <FormControl
                                    componentClass='select'
                                    style={{ width: '60%' }}
                                    value={this.state.closeType}
                                    onChange={this.handleCloseTypeChange}
                                >
                                    <option value={0}>- select -</option>
                                    {this.props.closeLoopManualConfirmTypes.map(item =>
                                        <option key={'d-' + item.id} value={item.id}>{item.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleMarkDonated}>Mark Donated</Button>
                    <Button bsStyle='link' onClick={this.props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal >
        );
    }
}

export default MarkDonated;